var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-select',{class:[
    _vm.showTextUp ? 'showTextUp-select' : '',
    _vm.showTextDown ? 'showTextDown-select' : ''
  ],attrs:{"clearable":"","placeholder":""},model:{value:(_vm.valueMine),callback:function ($$v) {_vm.valueMine=$$v},expression:"valueMine"}},_vm._l((_vm.options),function(item,index){return _c('el-option',{key:'t' + index + _vm.value,attrs:{"value":item.value,"label":item.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }